export const images = [
  { src: "/images/ronaldo.jpg", matched: false, alt: "ronaldo" },
  { src: "/images/ronaldo.jpg", matched: false, alt: "ronaldo" },
  { src: "/images/messi.jpg", matched: false, alt: "messi" },
  { src: "/images/messi.jpg", matched: false, alt: "messi" },
  { src: "/images/goku.jpg", matched: false, alt: "goku" },
  { src: "/images/goku.jpg", matched: false, alt: "goku" },
  { src: "/images/green.jpg", matched: false, alt: "green" },
  { src: "/images/green.jpg", matched: false, alt: "green" },
  { src: "/images/husky.jpg", matched: false, alt: "husky" },
  { src: "/images/husky.jpg", matched: false, alt: "husky" },
  { src: "/images/synapses.jpg", matched: false, alt: "synapses" },
  { src: "/images/synapses.jpg", matched: false, alt: "synapses" },
];
